(function () {
  const overlay = document.getElementById('sg-modal');
  if (!overlay) return;

  const sizeData = JSON.parse(document.getElementById('sg-data').textContent);
  const wrapper = document.querySelector('.sg-wrapper');
  const originalBtn = document.querySelector('.sg-trigger-btn');

  // Move modal to <body> so position:fixed isn't trapped inside an ancestor
  // with a CSS transform (Dawn's scroll-reveal animations apply transforms).
  document.body.appendChild(overlay);

  if (wrapper) wrapper.hidden = true;

  function findSizeLabel() {
    return Array.from(document.querySelectorAll('.form__label')).find(function (el) {
      var text = el.textContent.trim().toLowerCase();
      return text.startsWith('size') || text.startsWith('shoe size');
    });
  }

  function getActiveBtn() {
    return document.querySelector('.sg-trigger-btn--clone') || originalBtn;
  }

  // Clone the button into the size label rather than moving it, so the original
  // stays in .sg-wrapper and can be re-cloned after every variant-selects re-render.
  function relocateButton() {
    document.querySelectorAll('.sg-trigger-btn--clone').forEach(function (el) { el.remove(); });
    var sizeLabel = findSizeLabel();
    if (!sizeLabel || !originalBtn) return;
    sizeLabel.classList.add('sg-has-trigger');
    var clone = originalBtn.cloneNode(true);
    clone.classList.add('sg-trigger-btn--clone');
    clone.addEventListener('click', openModal);
    sizeLabel.appendChild(clone);
  }

  relocateButton();

  overlay.querySelector('.sg-close-btn').addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeModal(); });

  function openModal() {
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    overlay.querySelector('.sg-close-btn').focus();
  }

  function closeModal() {
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
    getActiveBtn()?.focus();
  }

  overlay.querySelectorAll('.sg-unit-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { setUnit(btn.dataset.unit); });
  });

  function setUnit(unit) {
    if (!sizeData[unit]) return;
    overlay.querySelectorAll('.sg-unit-btn').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.unit === unit ? 'true' : 'false');
    });
    overlay.querySelectorAll('#sg-table-body tr').forEach(function (row, i) {
      if (!sizeData[unit][i]) return;
      // Skip the region column cell so index j stays aligned with sizeData row values.
      row.querySelectorAll('td:not([data-region-cell])').forEach(function (cell, j) {
        cell.textContent = sizeData[unit][i][j];
        cell.className = j === 0 ? 'sg-size-label' : '';
      });
    });
  }

  function setRegion(r) {
    var data = sizeData[r] || [];
    var th = overlay.querySelector('[data-region-col]');
    if (th) th.textContent = r.toUpperCase();
    overlay.querySelectorAll('#sg-table-body tr').forEach(function (row, i) {
      var cell = row.querySelector('[data-region-cell]');
      if (cell) cell.textContent = data[i] != null ? data[i] : '—';
    });
  }

  function initRegionSelector() {
    var regionKeys = ['us', 'uk', 'aus', 'eu'];
    var available = regionKeys.filter(function (r) { return sizeData[r] && sizeData[r].length; });
    if (!available.length) return;

    var defaultRegion = available.includes('us') ? 'us' : available[0];

    // Build full-width button bar
    var bar = document.createElement('div');
    bar.className = 'sg-region-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Size system');

    available.forEach(function (r) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sg-region-btn';
      btn.dataset.region = r;
      btn.textContent = r.toUpperCase();
      btn.setAttribute('aria-pressed', r === defaultRegion ? 'true' : 'false');
      btn.addEventListener('click', function () {
        bar.querySelectorAll('.sg-region-btn').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.region === r ? 'true' : 'false');
        });
        setRegion(r);
      });
      bar.appendChild(btn);
    });

    // Build row
    var row = document.createElement('div');
    row.className = 'sg-region-row';
    row.appendChild(bar);

    // Insert before the unit toggle row
    var unitRow = overlay.querySelector('.sg-unit-row');
    if (unitRow) {
      unitRow.parentNode.insertBefore(row, unitRow);
    } else {
      overlay.querySelector('.sg-modal__body').prepend(row);
    }

    // Insert region <th> at position 1 in thead
    var thead = overlay.querySelector('.sg-size-table thead tr');
    if (thead) {
      var th = document.createElement('th');
      th.setAttribute('data-region-col', '');
      thead.insertBefore(th, thead.children[1]);
    }

    // Insert region <td> at position 1 in each tbody row
    overlay.querySelectorAll('#sg-table-body tr').forEach(function (tr) {
      var td = document.createElement('td');
      td.setAttribute('data-region-cell', '');
      tr.insertBefore(td, tr.children[1]);
    });

    setRegion(defaultRegion);
  }

  initRegionSelector();

  // Re-relocate the button after every variant change (Dawn re-renders variant-selects,
  // which destroys the previously relocated clone).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, relocateButton);
  }
})();
